// v2 cache-bump
(function(){
  var KEY='asuka_pop_done';
  var ov=document.getElementById('asukaPop');
  if(!ov) return;
  try{ if(localStorage.getItem(KEY)) return; }catch(e){}
  // Skip the popup for visitors arriving from Meta ads — they already have the 15% offer.
  try{
    var _qs=(window.location.search||'').toLowerCase();
    var _meta=/[?&](fbclid|igshid)=/.test(_qs)
      || /[?&]utm_source=(facebook|instagram|ig|meta|fb)(&|$)/.test(_qs)
      || /[?&]utm_medium=(paid|paid_social|cpc)(&|$)/.test(_qs)
      || /[?&](nopopup|skip_signup)=1(&|$)/.test(_qs);
    if(_meta){ try{localStorage.setItem(KEY,'1');}catch(e){} return; }
  }catch(e){}
  function show(){ ov.classList.add('is-open'); ov.setAttribute('aria-hidden','false'); document.documentElement.style.overflow='hidden'; }
  function done(){ ov.style.display='none'; document.documentElement.style.overflow=''; try{localStorage.setItem(KEY,'1');}catch(e){} }
  function view(v){ ov.setAttribute('data-view', v); }
  setTimeout(show, 8000);
  document.getElementById('asukaPopX').addEventListener('click', done);
  document.getElementById('asukaPopStay').addEventListener('click', function(){ view('step1'); });
  document.getElementById('asukaPopLeave').addEventListener('click', done);
  document.getElementById('asukaPopDone').addEventListener('click', done);
  var form=document.getElementById('asukaPopForm');
  form.addEventListener('submit', function(e){
    e.preventDefault();
    var inp=form.querySelector('[name="contact[email]"]');
    var email=(inp.value||'').trim();
    var err=document.getElementById('asukaPopErr');
    if(!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)){ err.textContent='Please enter a valid email.'; return; }
    err.textContent='';
    var btn=form.querySelector('button[type="submit"]'); var t=btn.textContent; btn.disabled=true; btn.textContent='Signing you up…';
    fetch(form.action, { method:'POST', body:new URLSearchParams(new FormData(form)), headers:{'X-Requested-With':'XMLHttpRequest'} })
      .then(function(){ view('success'); try{localStorage.setItem(KEY,'1');}catch(e){} })
      .catch(function(){ btn.disabled=false; btn.textContent=t; err.textContent='Something went wrong — please try again.'; });
  });
})();
